import { Link } from "react-router-dom";
import { SYLLAPLUS_LOGO_B64 } from "../constants";

export default function LegalPage({ title, effectiveDate, sections }) {
  return (
    <div style={{ minHeight: "100vh", background: "#FFFFFF", fontFamily: "sans-serif" }}>
      <div style={{ borderBottom: "0.5px solid #E5E7EB", padding: "16px 24px" }}>
        <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: "10px", textDecoration: "none" }}>
          <img src={`data:image/png;base64,${SYLLAPLUS_LOGO_B64}`} alt="SyllaPlus" style={{ width: "28px", height: "28px" }} />
          <span style={{ fontSize: "18px", fontWeight: "500", color: "#1C2B3A" }}>SyllaPlus</span>
        </Link>
      </div>
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "40px 24px 80px" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "600", color: "#1C2B3A", margin: "0 0 6px 0" }}>{title}</h1>
        <p style={{ fontSize: "13px", color: "#6B7280", margin: "0 0 32px 0" }}>Effective date: {effectiveDate}</p>
        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom: "24px" }}>
            <h2 style={{ fontSize: "16px", fontWeight: "600", color: "#1C2B3A", margin: "0 0 8px 0" }}>{s.heading}</h2>
            <p style={{ fontSize: "14px", lineHeight: "1.7", color: "#374151", margin: 0 }}>{s.body}</p>
          </div>
        ))}
        <div style={{ borderTop: "0.5px solid #E5E7EB", marginTop: "40px", paddingTop: "16px", display: "flex", gap: "16px", fontSize: "13px" }}>
          <Link to="/privacy" style={{ color: "#1C2B3A" }}>Privacy Policy</Link>
          <Link to="/terms" style={{ color: "#1C2B3A" }}>Terms of Service</Link>
        </div>
      </div>
    </div>
  );
}